import React from "react";
import ICardWidgetProps from "../../../../../../model/interface/dataStorage/card/ICardWidgetProps";
import ICardWidgetContainer from "../../../../../../model/interface/dataStorage/card/ICardWidgetContainer";
import MainContainerWidget from "../../../widget/ContainerWidget";
import ConditionEditor from "../../../form/FormElement/optionEditor/ConditionEditor";
import Collapse from "../../../../../shared/display/collapse/Collapse";

interface IState{
    conditionMet: boolean
}

class ContainerWidget extends React.Component<ICardWidgetProps<ICardWidgetContainer>, IState> {

    constructor(props: ICardWidgetProps<ICardWidgetContainer>) {
        super(props);
        this.state = {
            conditionMet: false
        }
    }

    componentDidMount() {
        const state = ContainerWidget.getDerivedStateFromProps(this.props)
        this.setState({conditionMet: !!state?.conditionMet})
    }

    static getDerivedStateFromProps(props: ICardWidgetProps<ICardWidgetContainer>) {
        const {functions, preview, options} = props
        if (preview && options.conditions) {
            return {conditionMet: ConditionEditor.evaluateConditions(options.conditions, functions.getValue)}
        }
        return null
    }

    render() {
        const {conditionMet} = this.state

        return (
            <div className={'overflow-hidden'}>
                <Collapse collapsed={conditionMet}>
                    <MainContainerWidget {...this.props}></MainContainerWidget>
                </Collapse>
            </div>

        );
    }
}

export default ContainerWidget